module.exports = __webpack_public_path__ + "static/media/brass.964687fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/brass.jpg
// module id = 639
// module chunks = 0